import { createSearchParams } from 'react-router-dom';
import type { DashboardAnnualDaySlot } from './dashboardAnnualDaySlots';
import {
  type AnnualProjectProgram,
  normalizeHexColorForProjectCompare,
} from './annualProjectProgramsStorage';

/** 수업 미니모달 '바로가기': 해당 차시가 선택된 프로그램 페이지 경로(이동 불가면 null) */
export function buildDashboardSlotProgramPath(
  slot: DashboardAnnualDaySlot,
  params: {
    gradeId: string;
    academicYear: number;
    fallbackTermNumber?: 1 | 2 | null;
    annualProjectPrograms: readonly AnnualProjectProgram[];
  }
): string | null {
  const gradeId = params.gradeId.trim();
  const annualKey = (slot.annualCellKey ?? '').trim();
  if (!gradeId || !annualKey) return null;
  const termNumber = (slot.termNumber ?? params.fallbackTermNumber ?? 1) as 1 | 2;
  const baseParams: Record<string, string> = {
    gradeId,
    programTerm: String(termNumber),
    programYear: String(slot.academicYear || params.academicYear),
    focusAnnualCellKey: annualKey,
  };
  if (slot.programKindLabel === '고정' || slot.fixedContentRowId) {
    return `/program/fixed?${createSearchParams(baseParams).toString()}`;
  }
  if (slot.programKindLabel === '프로') {
    const slotColor = normalizeHexColorForProjectCompare(slot.timetableColorHex);
    const project = params.annualProjectPrograms.find(
      (p) => p.termNumber === termNumber && normalizeHexColorForProjectCompare(p.colorHex) === slotColor
    );
    if (!project) return null;
    return `/program/project/${encodeURIComponent(project.id)}?${createSearchParams(baseParams).toString()}`;
  }
  const trackName = (slot.templateLabel ?? '').trim();
  if (!trackName) return null;
  const trackParams: Record<string, string> = { ...baseParams };
  const timetableName = (slot.timetableText ?? '').trim();
  if (timetableName) trackParams.programTimetableName = timetableName;
  return `/program/track/${encodeURIComponent(trackName)}?${createSearchParams(trackParams).toString()}`;
}
